import axios from "axios";
import { getAuthSession } from "../utils/authSession";

const obterMensagemErro = async (err) => {
  let errorMessage = "";

  if (err.response && err.response.data && err.response.data instanceof Blob) {
    const text = await err.response.data.text();

    try {
      const errorData = JSON.parse(text);
      if (err.response.status === 422 && errorData.messages) {
        errorMessage = `Erro de validacao: ${JSON.stringify(errorData.messages)}`;
      } else {
        errorMessage = errorData.message || "Erro ao gerar relatorio";
      }
    } catch (parseError) {
      errorMessage = "Erro ao processar resposta do servidor";
    }
  } else if (err.response && err.response.data) {
    if (err.response.status === 422) {
      errorMessage = `Erro de validacao: ${JSON.stringify(
        err.response.data.messages
      )}`;
    } else {
      errorMessage = err.response.data.message || "Erro ao gerar relatorio";
    }
  } else {
    errorMessage = err.message || "Erro ao conectar com o servidor";
  }

  return errorMessage;
};

const downloadPlanilha = async ({ endpoint, filtros, defaultFilename }) => {
  try {
    const API_URL = process.env.REACT_APP_API_URL;
    const session = getAuthSession();

    const response = await axios({
      method: "post",
      url: `${API_URL}${endpoint}`,
      data: filtros,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${session?.access_token}`,
      },
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    const contentDisposition = response.headers["content-disposition"];
    let filename = defaultFilename;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  } catch (err) {
    const errorMessage = await obterMensagemErro(err);
    return Promise.reject({ message: errorMessage });
  }
};

export const downloadRelatorio = async (filtros) =>
  downloadPlanilha({
    endpoint: "/resultados/planilha-resultados",
    filtros,
    defaultFilename: "resultados_eleicao.xlsx",
  });

export const downloadRelatorioPerfilEleitorado = async (filtros) =>
  downloadPlanilha({
    endpoint: "/perfil-eleitorado/planilha-perfil-agrupado",
    filtros,
    defaultFilename: "perfil_eleitorado.xlsx",
  });
